import axios from 'axios';

export const s3Client = axios.create({
  withCredentials: false,
});
